import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import ContactpersonModel from '../../../models/ContactpersonModel';
import DataService from "../../../services/data.service";
import { BusinessPartnerProps } from '../../../types/IdProps';
import AddContactpersonPopup from '../Popups/BusinessPartner_popup_AddContactperson';

const BusinessPartner_tab_Contactpersons: React.FC<BusinessPartnerProps> = ({ businessPartnerId, businessPartnerTypeId }) => {
    const [data, setData] = useState<ContactpersonModel[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();


    useEffect(() => {
        getTableData();
    }, [businessPartnerId]);

    function getTableData() {
        DataService.get<ContactpersonModel[]>('api/v1/Contactpersons/ByBusinessPartner/' + businessPartnerId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/Contactpersons/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { title: 'Name', dataProp: 'name', sort: 'asc'  },
        //{ title: 'Contactinfo', dataProp: 'contactinfo' },
        //{ title: 'Address', dataProp: 'address', dateType: 'address' },
    ];

    if (isAuthorizedFor(ApplicationFunctions.CreateContactperson) || isAuthorizedFor(ApplicationFunctions.DeleteContactperson)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            }
        );
    }

    return (
        <>
            <DataTable
                name='dtBusinessPartnerContactPersons'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Contactperson'
                navigateUrl='/plm/BusinessPartners/ContactPerson/'
            />
            {showPopup && <AddContactpersonPopup businessPartnerId={businessPartnerId} businessPartnerTypeId={businessPartnerTypeId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />}
        </>
    );
}
export default BusinessPartner_tab_Contactpersons;